import React from "react";
import "./App.css";

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import { HomePage } from "./pages/homePage";
import Layout from "./components/appLayout/layout";
import { AproposPage } from "./pages/aproposPage";
import { ContactPage } from "./pages/contactPage";
import { Services } from "./pages/servicesPage";
import { ConsultingPage } from "./pages/consultingPage";
import { MarketingPage } from "./pages/marketingPage";
import { DevPage } from "./pages/devPage";
import { DesignPage } from "./pages/designPage";
import DevisPage from "./pages/devisPage";
import { SimulationPage } from "./pages/simulationPage";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import RegisterForm from "./pages/connxionPage";
function App() {
  return (
    <>
      {/* Ton contenu */}
      <ToastContainer position="top-right" />
      <Router>
        <Routes>
          <Route
            path="/"
            element={
              <Layout>
                <HomePage />
              </Layout>
            }
          />
          <Route
            path="/apropos"
            element={
              <Layout>
                <AproposPage />
              </Layout>
            }
          />
          <Route
            path="/contact"
            element={
              <Layout>
                <ContactPage />
              </Layout>
            }
          />

          <Route
            path="/services"
            element={
              <Layout>
                <Services />
              </Layout>
            }
          />
          <Route
            path="/consulting"
            element={
              <Layout>
                <ConsultingPage />
              </Layout>
            }
          />
          <Route
            path="/marketing"
            element={
              <Layout>
                <MarketingPage />
              </Layout>
            }
          />
          <Route
            path="/developpement"
            element={
              <Layout>
                <DevPage />
              </Layout>
            }
          />
          <Route
            path="/design"
            element={
              <Layout>
                <DesignPage />
              </Layout>
            }
          />
          <Route
            path="/simulation"
            element={
              <Layout>
                <SimulationPage />
              </Layout>
            }
          />
          <Route
            path="/demandez-devis"
            element={
              <Layout>
                <DevisPage />
              </Layout>
            }
          />
          <Route
            path="/connexion"
            element={
              <Layout>
                <RegisterForm />
              </Layout>
            }
          />
        </Routes>
      </Router>
    </>
  );
}

export default App;
